import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {

  @Input() public date:any;
  @Input() public error:string;
  @Input() public element:string;
  @Input() public minDate:string;
  @Input() public maxDate:string;
  @Output() public callback:EventEmitter<string> = new EventEmitter;

  public now:string;
  private dateObject: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {

    if (changes.date) {
      this.setModel();
    }

    if(changes.minDate || changes.maxDate) {
      this.defineLimites();
    }

  }

  ngOnInit() {
      setTimeout( () => {
        this.getNow();
        this.start();
      }, 200);
  }

  setModel(){
    if (!this.date) {
      this.date = this.getNow();
    }
    const dateSetModel = this.isoToMX(this.date.slice(0,10));
    //translate format
    this.input().val(dateSetModel).trigger('change');
  }

  input(){
    return $('#' + this.element);
  }

  emit(){
    this.defineLimites();
    const fecha = this.mxToISO(this.input().val());
    //translate format
    this.callback.emit(fecha);
  }

  defineLimites() {
    //los métodos setMinDate y setMaxDate no existen en la documentación de daterangepicker. Parecen no estar haciendo lo que deberían: https://www.daterangepicker.com/
    const date = this.input().val();
    if (this.maxDate) {
      let dateObject =  this.input().data('daterangepicker')
      if (dateObject) {
        dateObject.setMaxDate(this.maxDate);
      } 
    }
    if (this.minDate) {
      let dateObject =  this.input().data('daterangepicker')
      if (dateObject) {
        dateObject.setMinDate(this.minDate);
      } 
    }
    this.input().val(date).trigger('change');
  }

  start(){
    this.dateObject = this.input().daterangepicker({
      singleDatePicker: true,
      showDropdowns: true,
      maxDate: (this.maxDate != 'now')?this.maxDate:this.now,
      minDate: (this.minDate != 'now')?this.minDate:this.now,
      locale: {
        format: 'DD/MM/YYYY'
      }
    });
    const that = this;
    this.input().on('apply.daterangepicker', function(ev, picker) {
      that.emit();
    });

    this.setModel();
    this.emit();
  }

  getNow() {
    
    if(!this.now) {
      this.now = new Date().toISOString().slice(0,10);
    }

    return this.now;
  }

  isoToMX(dateString){
    const year = dateString.slice(0,4);
    const month = dateString.slice(5,7);
    const day = dateString.slice(8,10);
    
    return  day+'/'+month+'/'+year;

  }

  mxToISO(dateString){
    const year = dateString.slice(6,10);
    const month = dateString.slice(3,5);
    const day = dateString.slice(0,2);

    return  year+'-'+month+'-'+day;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/tools/datepicker/datepicker.component.ts